import type { CityConfig } from "../city-template/types";

export const morgantownConfig: CityConfig = {
  city: "Morgantown",
  state: "West Virginia",
  stateAbbr: "WV",
  slug: "morgantown",
  route: "/morgantown",
  title: "Emergency Passport Morgantown, WV — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Morgantown, WV — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving WVU students, Monongalia County families, and North Central West Virginia travelers.",
  h1: "Emergency & Expedited Passport Services in Morgantown, WV",
  heroSubtitle: "WVU study abroad program to Barcelona starting in three weeks? Mylan or WVU Medicine international conference in Geneva? Family trip to Ireland departing from Pittsburgh International? We help Morgantown residents — from WVU students in Sunnyside to Cheat Lake families to Westover professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Morgantown%20West%20Virginia%20with%20West%20Virginia%20University%20campus%20and%20Woodburn%20Hall%20in%20autumn%2C%20Monongahela%20River%20flowing%20through%20the%20valley%20with%20colorful%20fall%20foliage%20on%20surrounding%20hills%2C%20warm%20golden%20hour%20sunlight%20illuminating%20the%20university%20buildings%20and%20riverfront%2C%20elevated%20scenic%20viewpoint%20capturing%20the%20classic%20college%20town%20nestled%20in%20Appalachian%20mountains&width=1800&height=700&seq=morgantown-hero-2026&orientation=landscape",
  heroImageAlt: "Morgantown West Virginia with WVU campus and Monongahela River at autumn golden hour",
  geoPosition: "39.6295;-79.9559",
  geoPlacename: "Morgantown, West Virginia",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 210 miles from Morgantown — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Morgantown", zips: "26501, 26505, 26506, 26507, 26508" },
    { name: "Star City", zips: "26505" },
    { name: "Westover", zips: "26501" },
    { name: "Granville", zips: "26534" },
    { name: "Cheat Lake", zips: "26508" },
    { name: "Fairmont", zips: "26554, 26555" },
    { name: "Clarksburg", zips: "26301, 26302" },
    { name: "Bridgeport", zips: "26330" },
    { name: "Kingwood", zips: "26537" },
    { name: "Grafton", zips: "26354" },
  ],
  benefits: [
    { icon: "ri-graduation-cap-line", title: "WVU Study Abroad Expert", desc: "West Virginia University sends hundreds of students abroad each year. We specialize in fast-turnaround student passports — from first-time applications to last-minute renewals before program orientation deadlines." },
    { icon: "ri-flight-takeoff-line", title: "Pittsburgh Airport Gateway", desc: "Morgantown has no international flights — PIT is the primary departure point. We coordinate timelines around the 75-mile drive and PIT check-in requirements for your specific airline and destination." },
    { icon: "ri-hospital-line", title: "Medical & Research Travel", desc: "WVU Medicine, Ruby Memorial, and NIOSH researchers attend international conferences and training — often on short notice. We handle professional passport needs with the speed healthcare and academic careers demand." },
    { icon: "ri-building-2-line", title: "Corporate Travel Ready", desc: "Mylan Pharmaceuticals, WVU Research Corporation, and Morgantown-area businesses with international operations count on predictable, fast passport processing for employee travel." },
  ],
  testimonials: [
    {
      name: "Dr. Sarah M.",
      location: "Cheat Lake",
      rating: 5,
      text: "I had a medical conference in Zurich and realized my passport was expired just 8 days before departure. Fast Passport Center handled everything remotely and got it back in 4 days. Absolutely saved my presentation.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Tyler J.",
      location: "WVU Downtown Campus",
      rating: 5,
      text: "WVU study abroad orientation was in two weeks and I had never had a passport. They walked me through the first-time application step by step and my passport arrived before my flight to Madrid.",
      service: "New Passport — First Time",
    },
    {
      name: "The Patel Family",
      location: "Star City",
      rating: 5,
      text: "Family trip to India booked months ago, but we discovered our youngest needed a new child passport. They guided us through every form and the acceptance visit. Passport arrived in 6 days.",
      service: "Child Passport",
    },
    {
      name: "Marcus W.",
      location: "Westover",
      rating: 5,
      text: "Pharmaceutical industry conference in Frankfurt booked by my company with 10 days notice. I needed a name change correction too. They handled both the correction and expedited processing simultaneously.",
      service: "Name Change + Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "morgantown-1",
      name: "Morgantown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Virginia Ave",
      city: "Morgantown",
      state: "WV",
      zip: "26505",
      phone: "(304) 296-3677",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Morgantown",
      website: "https://tools.usps.com/find-location.htm?location=1367618",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Morgantown. Passport photos available on-site. Appointment strongly recommended — walk-in availability is limited, especially during WVU semester start and end periods.",
      icon: "ri-mail-line",
    },
    {
      id: "morgantown-2",
      name: "Monongalia County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "243 High St, Room 110",
      city: "Morgantown",
      state: "WV",
      zip: "26505",
      phone: "(304) 291-7239",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Downtown Morgantown — Courthouse",
      website: "https://www.monongaliacounty.gov/circuit-clerk",
      websiteLabel: "Monongalia County Clerk",
      notes: "County clerk office accepting passport applications. Located in the county courthouse. Often less crowded than the post office. No photo services — obtain photos beforehand.",
      icon: "ri-government-line",
    },
    {
      id: "morgantown-3",
      name: "Star City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3100 University Ave",
      city: "Star City",
      state: "WV",
      zip: "26505",
      phone: "(304) 599-5244",
      hours: "Mon–Fri 9:00 AM – 12:00 PM, 1:00 PM – 4:00 PM",
      distance: "Star City — 3 miles north of WVU campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Smaller facility serving northern Morgantown and Star City residents. Limited hours — call ahead to confirm availability. Alternative to the busy downtown post office.",
      icon: "ri-mail-line",
    },
    {
      id: "morgantown-4",
      name: "Fairmont Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "331 Cleveland Ave",
      city: "Fairmont",
      state: "WV",
      zip: "26554",
      phone: "(304) 363-0758",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Fairmont — 20 miles south of Morgantown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Marion County and southern Monongalia County. Alternative location when Morgantown appointments are full. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "morgantown-5",
      name: "Kingwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "106 E Main St",
      city: "Kingwood",
      state: "WV",
      zip: "26537",
      phone: "(304) 329-1163",
      hours: "Mon–Fri 9:00 AM – 12:00 PM, 1:00 PM – 3:00 PM",
      distance: "Kingwood — 15 miles east, Preston County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Preston County residents. Very limited hours — call ahead. Good option for eastern Monongalia County residents avoiding Morgantown traffic.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "How fast can I get a passport in Morgantown?", a: "We offer Morgantown-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. There is no passport agency in Morgantown — the nearest is Washington, DC, 210 miles away. Our courier service eliminates the need to drive to DC and wait for an agency appointment." },
    { q: "Do I need to visit an office in Morgantown?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Morgantown Main Post Office or Monongalia County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Morgantown address." },
    { q: "Can WVU students get passports quickly for study abroad?", a: "Yes — we specialize in WVU student passports. First-time applicants need an acceptance facility visit (we guide you to the nearest available location), then we expedite the processing. Many WVU students receive passports within 5–10 days. We understand study abroad deadlines, orientation dates, and the tight timeline between acceptance and departure." },
    { q: "What airport do Morgantown travelers use for international flights?", a: "Morgantown Municipal Airport (MGW) serves only domestic routes. Most international travelers drive to Pittsburgh International Airport (PIT), about 75 miles north. Some travelers also use Washington Dulles (IAD, ~190 miles) or Baltimore-Washington (BWI, ~200 miles). We help coordinate your passport timeline with your specific airport departure." },
    { q: "What is the best price for expedited passport service in Morgantown?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Where can I get a passport photo in Morgantown?", a: "CVS Pharmacy on University Avenue, Walgreens on Patteson Drive, the UPS Store on High Street, and the WVU Mountainlair student center all offer passport photos. The Morgantown Main Post Office also provides photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "Does WVU have passport acceptance on campus?", a: "WVU does not have a dedicated campus passport office, but the Morgantown Main Post Office (300 Virginia Ave) is within walking distance of downtown campus. The Monongalia County Clerk at the courthouse on High Street is also convenient for students living near the downtown area." },
    { q: "What documents do Morgantown first-time applicants need?", a: "Certified birth certificate, government-issued photo ID (WV driver's license or WVU ID with photo), completed DS-11 form, and passport photo. If you were born in another state, you can order a certified birth certificate through vital records. We provide a personalized Morgantown-specific checklist." },
    { q: "Can I check my passport status from Morgantown?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system. Processing from submission to final return shipping typically matches your chosen speed tier, and we provide regular updates throughout." },
    { q: "What about international travel for WVU faculty and researchers?", a: "WVU faculty, medical researchers at Ruby Memorial, and NIOSH scientists often travel internationally for conferences, collaborations, and training. We understand the academic calendar, grant deadlines, and the need for predictable processing. Many faculty travelers book with 2–4 weeks notice and receive passports well before departure." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — University Ave", address: "455 University Ave, Morgantown, WV 26505", hours: "Daily 8 AM – 9 PM" },
    { name: "Walgreens — Patteson Drive", address: "1100 Van Voorhis Rd, Morgantown, WV 26505", hours: "Daily 8 AM – 10 PM" },
    { name: "The UPS Store — High Street", address: "369 High St, Morgantown, WV 26505", hours: "Mon–Fri 8:30 AM – 6 PM, Sat 9 AM – 1 PM" },
    { name: "Morgantown Main Post Office", address: "300 Virginia Ave, Morgantown, WV 26505", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Walmart Supercenter — University Town Centre", address: "5045 University Town Centre Dr, Morgantown, WV 26501", hours: "Daily 6 AM – 11 PM" },
  ],
  dmvLocations: [
    {
      name: "WV DMV — Morgantown Regional Office",
      address: "308 Scott Ave, Morgantown, WV 26508",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, state ID cards. Appointment recommended — walk-ins accepted but expect wait times.",
      featured: true,
    },
  ],
  dmvWebsite: "https://transportation.wv.gov/dmv/",
  dmvLabel: "West Virginia DMV — Official Website",
  airports: [
    {
      code: "PIT",
      name: "Pittsburgh International Airport",
      distance: "About 75 miles north of Morgantown",
      address: "1000 Airport Blvd, Pittsburgh, PA 15231",
      note: "Primary international gateway for Morgantown travelers. Direct flights to London, Paris, Frankfurt, and Cancun. About 75–90 minutes drive via I-79.",
      flightUrl: "https://flypittsburgh.com/",
      flightLabel: "PIT Airport Website",
      featured: true,
    },
    {
      code: "MGW",
      name: "Morgantown Municipal Airport",
      distance: "About 3 miles east of downtown Morgantown",
      address: "100 Hart Field Rd, Morgantown, WV 26505",
      note: "Regional airport with limited commercial service. No international flights — connection point to PIT or IAD for international travel. Southern Airways Express service.",
      flightUrl: "https://www.morgantownwv.gov/366/Airport",
      flightLabel: "MGW Airport Website",
      featured: false,
    },
    {
      code: "IAD",
      name: "Washington Dulles International Airport",
      distance: "About 190 miles southeast of Morgantown",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub with direct flights to Europe, Asia, Middle East, and Latin America. United Airlines hub. About 3.5 hours drive via I-68 and I-70.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "Dulles Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate — WV DHHR",
      desc: "Request certified birth certificates from the West Virginia Department of Health and Human Resources Vital Registration Office. Online, mail, or in-person options.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate — Monongalia County",
      desc: "Request marriage license records from the Monongalia County Clerk. Certified copies available for name changes and passport applications.",
      url: "https://www.monongaliacounty.gov/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree — Monongalia County",
      desc: "Obtain certified divorce records through the Monongalia County Circuit Clerk. Required for name change passport corrections.",
      url: "https://www.monongaliacounty.gov/circuit-clerk",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate — WV DHHR",
      desc: "Obtain certified death certificates through WV DHHR Vital Registration. Required for estate and legal matters.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "International flight from Pittsburgh departing in two days? Conference in London this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Morgantown-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Morgantown residents renew fast — no agency visit required for most renewals. Perfect for WVU faculty, Cheat Lake families, and Monongalia County professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport — First Time",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Morgantown residents through every step — from WVU students to Star City families — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your international trip from Pittsburgh or Dulles stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for WVU researchers, pharmaceutical executives, and consultants who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Morgantown-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Morgantown WV", description: "Urgent passport processing for Morgantown West Virginia travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Morgantown WV", description: "Fast passport renewal for Morgantown West Virginia residents with a previously-issued passport." },
    { name: "First-Time Passport Morgantown WV", description: "New passport application services for Morgantown West Virginia residents applying for their first passport." },
    { name: "Child Passport Morgantown WV", description: "Minor passport services for Morgantown West Virginia families with children under 16." },
    { name: "Name Change Passport Morgantown WV", description: "Passport name correction after marriage, divorce, or legal name changes for Morgantown residents." },
    { name: "Second Passport Morgantown WV", description: "Second passport services for Morgantown corporate and academic international travelers." },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Underestimating Drive Time to Pittsburgh Airport",
      description: "Morgantown travelers often forget that PIT is 75 miles away — about 75–90 minutes by car. A passport delay combined with PIT drive time can mean a missed international flight. We flag this immediately and build the full timeline into your processing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "WVU Students Waiting Until the Last Week",
      description: "Every semester, dozens of WVU students discover they need a passport the week before study abroad orientation. First-time applications require an acceptance visit, and standard mail can take 6–8 weeks. We offer expedited processing but the sooner you start, the less stressful the timeline.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Morgantown pharmacies and big-box stores produce photos that fail State Department standards — wrong background color, shadows, incorrect size. We catch this in review before it causes a rejection and delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Morgantown families frequently overlook the DS-3053 notarized consent form when one parent cannot attend the acceptance visit. This is an automatic rejection — we guide you through it correctly before you go.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Checking the 6-Month Validity Rule",
      description: "Many Morgantown travelers booking trips to Europe, Asia, or South America do not realize their passport must have 6 months remaining beyond the return date. We check this immediately during document review.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or WVU dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist with instructions tailored to your travel situation and departure airport." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Morgantown clients ship from the UPS Store on High Street or from home." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Washington, DC or wait for a passport agency appointment." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected and shipped back to your Morgantown address. No office visit, no DC drive." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — nearest agency is in Washington DC (210 miles)", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — nearest is Washington DC, 210 miles away. Typically booked 2+ weeks out", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 210 miles to Washington DC Passport Agency", fpc: "Most Morgantown travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "WV-Specific Guidance", agency: "Generic — no WVU study abroad, PIT airport, or Mon County expertise", fpc: "Full Morgantown/PIT/WVU knowledge built in" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Fast passport services in Charleston, WV", route: "/charleston" },
    { name: "Expedited passport in Huntington, WV", route: "/huntington" },
    { name: "Quick passport services in Fairmont, WV", route: "/fairmont" },
    { name: "Urgent passport services in Parkersburg, WV", route: "/parkersburg" },
    { name: "West Virginia passport services overview", route: "/west-virginia" },
  ],
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeNote: "Fast Passport Center serves Morgantown via secure registered courier with direct access to the Washington, DC Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 210 miles to DC. Morgantown residents can ship from any UPS Store, FedEx Office, or post office location across Monongalia County.",
  fpcOfficeDistance: "Serving Morgantown, Star City, Westover, Cheat Lake, Granville, and all Monongalia County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Morgantown and the greater Monongalia County area. From the WVU downtown campus to the Suncrest and Cheat Lake neighborhoods, from Star City and Westover to Granville and Kingwood — we serve all of North Central West Virginia. Our courier service eliminates the need to drive 210 miles to the Washington, DC Passport Agency.",
  nearbyCitiesIntro: "We serve Morgantown and all surrounding Monongalia County communities including Star City, Westover, Granville, Cheat Lake, as well as Fairmont, Clarksburg, Bridgeport, and Kingwood. We also serve WVU students and faculty traveling internationally from Pittsburgh International Airport.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Morgantown as simple as possible — with the efficiency and reliability WVU students, Monongalia County families, and Morgantown professionals need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Morgantown travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Morgantown travelers encounter unique passport issues — everything from WVU study abroad deadlines to Pittsburgh airport drive time coordination. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Morgantown travelers — from WVU students to Cheat Lake families to pharmaceutical industry professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Morgantown, WV? Here are the most common ones we hear from Morgantown-area travelers.",
  statePageRoute: "/states/west-virginia",
  statePageName: "West Virginia",
  servicesIntro: "Whether you need a renewal before a PIT flight to London, an emergency passport for a last-minute WVU study abroad program, or a first-time passport for a family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party resellers.",
  travelTiming: {
    title: "Travel & Passport Timing for Morgantown Residents",
    intro: "Morgantown's position as a university town 75 miles from the nearest international airport creates unique passport timing challenges. Here's what Morgantown travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PIT — Pittsburgh International Airport",
        subtitle: "Primary international gateway, 75 miles north via I-79",
        description: "Pittsburgh International handles direct flights to London, Paris, Frankfurt, Cancun, and 50+ international destinations. For Morgantown travelers, PIT is the default departure point for international travel. The 75-mile drive takes about 75–90 minutes, and combined with check-in requirements means you need to leave Morgantown at least 3–4 hours before a PIT international departure.",
        tip: "Factor the PIT drive time into your passport processing timeline. A passport arriving the day before departure leaves very little margin if anything goes wrong with the drive, weather, or airport check-in.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "WVU Study Abroad & Student Travel",
        subtitle: "Hundreds of WVU students abroad each semester",
        description: "West Virginia University runs extensive study abroad programs through the Office of Global Affairs, sending students to Spain, Italy, United Kingdom, China, Japan, Australia, and dozens of other countries. The acceptance-to-departure window is often just 6–10 weeks, and many students — especially first-generation college students — have never held a passport. The tight timeline between program acceptance and orientation creates regular passport urgencies.",
        tip: "First-time applicants must visit an acceptance facility in person. The Morgantown Main Post Office is walking distance from WVU downtown campus. Book your appointment as soon as you receive your study abroad acceptance letter.",
      },
      {
        icon: "ri-hospital-line",
        title: "Medical & Research Conference Travel",
        subtitle: "WVU Medicine, Ruby Memorial, NIOSH researchers",
        description: "Morgantown is home to WVU Medicine, one of the largest healthcare systems in West Virginia, and the National Institute for Occupational Safety and Health (NIOSH) research facility. Faculty physicians, medical researchers, and public health professionals regularly travel to international conferences — sometimes on 2–3 weeks notice. Conference presentation dates are fixed and unmovable, making predictable passport processing essential.",
        tip: "Conference travel is often booked on short notice — sometimes just 10–14 days before departure. Our expedited courier service is designed for exactly these scenarios, with processing as fast as 24 hours.",
      },
      {
        icon: "ri-building-2-line",
        title: "Pharmaceutical & Corporate Travel",
        subtitle: "Mylan, WVU Research Corp, Morgantown businesses",
        description: "Morgantown's pharmaceutical and research sectors — anchored by Mylan Pharmaceuticals (now part of Viatris) and WVU Research Corporation — generate regular international business travel. Corporate meetings, supplier visits, regulatory submissions, and training programs all require passports that are valid, current, and ready when business calls. Travel is often booked by corporate travel desks that do not check passport expiration dates.",
        tip: "Self-check your passport expiration date regularly, even if your company travel desk books your flights. Many Morgantown business travelers discover expired passports only when packing for a trip.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Morgantown's Pittsburgh Connection",
      description: "Morgantown is culturally and economically tied to Pittsburgh — many residents commute between the two cities, and Pittsburgh is the go-to airport, shopping destination, and cultural hub for North Central West Virginia. This connection means Morgantown travelers default to PIT for international departures, and we build the full PIT timeline — drive, parking, check-in, security — into every passport processing plan.",
    },
  },
  destinations: {
    title: "Where Morgantown Travelers Go — And Why Passports Get Urgent",
    intro: "Morgantown's mix of WVU students, medical professionals, researchers, and families creates diverse international travel patterns. Here are the most common destinations and urgency patterns.",
    stats: [
      { stat: "45%", label: "of Morgantown expedited requests are WVU study abroad or student-related" },
      { stat: "2–3 Weeks", label: "average lead time from booking to international departure for Morgantown travelers" },
      { stat: "Mar–May", label: "peak season when study abroad deadlines, spring break, and academic conference season collide" },
      { stat: "48 Hours", label: "shortest turnaround for a WVU researcher departing to a conference in London" },
    ],
    destinations: [
      { name: "Italy & Spain", context: "WVU study abroad programs in Florence, Rome, Barcelona, Madrid, and Valencia", urgency: "Study abroad acceptances typically released 6–8 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "PIT-London direct flight, WVU exchange programs, medical conferences, academic collaborations", urgency: "Conference dates fixed and unmovable; bookings often 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Germany & Switzerland", context: "Pharmaceutical industry conferences, WVU engineering exchanges, Rhine-Ruhr research collaborations", urgency: "Corporate travel often booked with 1–2 week lead time", icon: "ri-map-pin-2-line" },
      { name: "China & Japan", context: "WVU Asian studies programs, pharmaceutical supply chain travel, academic partnerships with Chinese universities", urgency: "Visa requirements add extra timeline pressure beyond passport processing", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Spring break student travel, family resort vacations, Cancun and Punta Cana all-inclusive packages", urgency: "Spring break bookings peak January–February for March travel", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "WVU semester exchange programs, research fellowships, post-graduation travel", urgency: "Semester exchange acceptances often 8–10 weeks before departure", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other West Virginia Service Areas",
    crossLinksDesc: "We serve travelers across the Mountain State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Charleston", route: "/charleston" },
      { name: "Huntington", route: "/huntington" },
      { name: "Fairmont", route: "/fairmont" },
    ],
  },
};